import { Navigate, Outlet, useParams } from 'react-router-dom'

export default function ProjectTablesRouting() {
  const { view } = useParams()
  if (!view) return <Navigate to="/documents" replace />
  const isValidView = /documents|data/gi.test(view)
  return isValidView ? <Outlet /> : <Navigate to="/documents" replace />
}
